import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const matchingExplainabilityCrudActionTypes = generateEntityCrudActionTypes('matchingExplainability')

export default { ...matchingExplainabilityCrudActionTypes }
